





























import { Global } from '@/store/globalz';
import { BModal } from 'bootstrap-vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CurrencyBar from '../CurrencyBar.vue';
import BlackPearlShop from './shop/BlackPearlShop.vue';

@Component({
  components: {
    CurrencyBar,
    BlackPearlShop,
  },
})
export default class ShopModal extends Vue {
  public baseUrl = process.env.BASE_URL;
  public created() {
    Global.shopModal = this;
  }

  public show() {
    (this.$refs.myModal as BModal).show();
  }
  public toHome() {
    this.$router.push({ name: 'Home' });
    (this.$refs.myModal as BModal).hide();
  }
}
